import {v3} from "oc-threejs/short3.js";
import Maths3 from "oc-threejs/Maths3";
import Snap from "oc-interaction/snaps2/Snap";
import Element from "../arrangement/Element";

/**
 */
export default class KonstruktionsbodenSnap extends Snap {

    element: Element;
    y: number;

    /**
     */
    constructor(options) {
        super(options);
        this.element = options.element;
        this.y = options.y ? options.y : 0;
        this.yTransformation = options.yTransformation;
        this.active = false;
    }

    /**
     */
    accept() {
        return this.dragObject3d.vsData.element === this.element;
    }

    /**
     */
    perform(dropped) {
        const distance = Math.abs(this.yTransformation(this.y) - this.dragObject3d.position.y);
        if (this.active) {
            if (distance>this.radiusSnapEnd) {
                this.active = false;
            }
        } else {
            if (distance<this.radiusSnapStart) {
                this.active = true;
            }
        }
        if (this.active) {
            this.dragObject3d.position.y = this.yTransformation(this.y);
        }
        return this.active;
    }

    /**
     */
    showForDebug() {
        return Debugs.plane(new THREE.Plane().setFromNormalAndCoplanarPoint(Maths3.vector.y,v3(0,y,0)),STAGE.settings.dragDrop.snapsDebugColor);
    }

}
